import React from 'react';
import "../styleFiles/AboutMe.css"
import { Link } from "react-router-dom";

const AboutMe = () => {

    return (
        <>
            <section className='row row-cols-1 row-cols-lg-2 m-auto'>
                <div className='col profile-img-container'>
                    <img src="/assets/ahmed.jpg" alt="Ahmed Osama" className="profile-img" />
                </div>
                <div className='col align-content-center mt-4'>
                    <h1> Ahmed Osama Fawzy </h1>
                    <h5> <i class="fa-solid fa-graduation-cap"></i> <b>Graduate</b> of FCAI, Cairo Unversity </h5>
                    <h5> <i class="fa-solid fa-users-between-lines"></i> <b>Founder</b> of Elkhayal SW Development </h5>
                </div>
            </section>
            <div>
                <section>
                    <div className='Container'>
                        <h4> About Me </h4>
                        <span> 
                            I’m Ahmed Osama Fawzy <b>Software Engineer.</b><br/> Graduate of the Faculty of Computers and Artificial Intelligence, Department of Artificial Intelligence, Cairo University <br/> As the co-founder of <b>Elkhayal Software Company</b>, I design and develop full-stack web systems and AI-powered applications.
                            I also continue expanding my expertise in mobile development, machine learning, deep learning and computer vision.
                            I build software that’s clean, intelligent, and impactful.
                        </span>
                    </div>
                </section>

                <section>
                    <div className='Container'>
                        <h4> Get Touch With Me </h4>
                        <span> 
                            Take a look at my portfolio to see how I turn ideas into real, meaningful projects. Feel free to reach out through the contact page or <b>grab a copy of my resume</b> to learn more.
                        </span><br/>
                        <button className='LightButton'> <i class="fa-solid fa-download"></i> <a href="/assets/CV.pdf" download>Download CV</a> </button>
                        <button className='LightButton'> <i class="fa-solid fa-handshake"></i> <Link to="/contactus"> Contact Page </Link> </button>
                    </div>
                </section>
            </div>
        </>
    )

}

export default AboutMe;